<template>
    <div>
        <b-tabs v-if="bodyguardService">
            <b-tab title="Información" active>
                <app-bodyguard-service-general-info
                    :service="bodyguardService"
                />
            </b-tab>
            <b-tab
                v-if="bodyguardService.body_guard_service_checkpoints.length"
                title="Puntos de control"
                class="pt-3"
            >
                <app-bodyguard-serices-card-checkpoints-map
                    :checkpoints="
                        bodyguardService.body_guard_service_checkpoints
                    "
                />
                <app-service-checkpoints-List
                    :data="bodyguardService.body_guard_service_checkpoints"
                    :seeActions="false"
                />
            </b-tab>
            <b-tab title="Herramientas">
                <b-row class="my-3">
                    <b-col
                        cols="6"
                        md="4"
                        lg="3"
                        v-for="tool in bodyguardService.body_guard_service_tools"
                        :key="tool.id"
                    >
                        <b-img fluid thumbnail :src="tool.photo_url"></b-img>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab
                title="novedades"
                :disabled="!bodyguardService.body_guard_service_notes.length"
            >
                <app-data-table
                    :fields="newsFields"
                    :items="bodyguardService.body_guard_service_notes"
                >
                    <template #index="{row}">
                        {{ row + 1 }}
                    </template>
                    <template #created_at="{item}">
                        {{ item.created_at | datetime }}
                    </template>
                </app-data-table>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import ServiceCheckpointsList from '../../ActiveBodyguardServicePage/ServiceCheckpointsList/ServiceCheckpointsList'
import BodyguardServiceGeneralInfo from './BodyguardServiceGeneralInfo'
import BodyguardSericesCardCheckpointsMap from './BodyguardServicesCardCheckpointsMap/BodyguardSericesCardCheckpointsMap'
export default {
    components: {
        appServiceCheckpointsList: ServiceCheckpointsList,
        appBodyguardServiceGeneralInfo: BodyguardServiceGeneralInfo,
        appBodyguardSericesCardCheckpointsMap: BodyguardSericesCardCheckpointsMap,
    },
    props: {
        bodyguardService: {
            required: true,
        },
    },
    data: () => ({
        newsFields,
    }),
}

const newsFields = [
    {
        key: 'index',
        label: '#',
    },
    {
        key: 'novelty',
        label: 'Novedad',
    },
    {
        key: 'created_at',
        label: 'Fecha',
    },
]
</script>
